export const validarEmail = (email) => {
  try {
    let re = /\S+@\S+\.\S+/;
    return re.test(email);
  } catch (error) {
    return false;
  }
};
